function preparePlugins(container) {
    container.find(".drop-down-wrap").each(function () {
        $(this).optimusDropDown();
    });
}

$(document).ready(function() {

    preparePlugins($(document));

    let options={
        theme:"default",
        position:"bottom",
        distance:20,
        borderRadius:4,
        background:"#20437f",
        backgroundOpacity:"1",
        fontSize:14,
        text:"Tyto webové stránky používají k poskytování svých služeb soubory Cookies. Používáním těchto webových stránek souhlasíte s použitím souborů Cookies.",
        html:false,
        textColor:"#fff",
        showButton:true,
        buttonText:"SOUHLASÍM!",
        buttonColor:"#20437f",
        buttonBgColor:"#fff",
        moreButtonText:"Více informací o Cookies",
        moreButtonColor:"#fff",
        moreButtonLink:"https://www.cookie-lista.cz/co-je-cookies.html",
        showCloseButton:false,
        cookieDays:365
    };

    $("body").BeeCookie(options);

    $("#move-to-top").moveTop();

    $(document).on("mouseover", ".price-list a", function () {
        $(this).find("img").addClass("animate");
    });

    flashes.forEach(function (v, k) {
        toastr[v.type](v.message);
    });

    $("#run-test").on("click", function (e1) {

        let btn = $(this);

        if($(this).prop('disabled')){
            return false;
        }

        $(this).closest("form").submit(function (e2) {

            if(e2.isDefaultPrevented()){
                return false;
            }

            let formData = new FormData(this);
            e1.preventDefault();
            e2.preventDefault();

            btn.prop('disabled', true);

            let textarea = $(this).find("textarea");
            if(textarea.length && textarea.val() === 'Zpráva *') {
                textarea.val("");
                textarea.focus().blur();
                textarea.val('Zpráva *');
                return false;
            }

            let formUrl = $(this).attr("action");

            grecaptcha.ready(function () {
                grecaptcha.execute('6Le5GR4aAAAAAJQDf8uuUe9_CewxHs3o4_UCw5HL', {action: 'homepage'}).then(function (token) {

                    formData.append('token', token);
                    formData.append('action', 'homepage');

                    $.nette.ajax({
                        url: formUrl,
                        data: formData,
                        type: 'POST',
                        processData: false,
                        contentType: false,
                        off: {
                            snippets: true
                        },
                        success: function (payload) {

                            if(isDefined(payload.testUrl)) {

                                let progress = new ProgressDialog();
                                progress.message = 'Připravujeme pro Vás test. <br /> Tato akce může trvat několik vteřin.';
                                progress.init();

                                location.href = payload.testUrl;
                            }

                        }, error: function () {
                            btn.prop('disabled', false);
                        }
                    });
                });
            });

        });

    });

    $('input[type="text"], input[type="email"]').on("focus", function () {
        $(this).data('placeholder', $(this).attr('placeholder'));
        $(this).attr('placeholder', '');
    }).on("blur", function () {
        $(this).attr('placeholder', $(this).data('placeholder'));
    });

    $("textarea").on("focus", function () {
        $(this).removeClass('placeholder');
        if($(this).val() === 'Zpráva *') {
            $(this).val('');
        }
    });

    $("textarea").on("blur", function () {
        if($(this).val() === ""){
            $(this).val('Zpráva *');
        }
        if($(this).val() === 'Zpráva *') {
            $(this).addClass('placeholder');
        }
    });

    $.nette.init();

    $.nette.ext({
        complete: function (payload) {
            preparePlugins($("body"));
        }
    });

});